import React from 'react';
import I18n from 'i18n-js';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import BumpRecommendationBody from './bump_modal_body_container';
import { BumpModalShell } from './BumpModalShell';
import { bumpRecommendationsController, BumpControllerProps, WrappedBumpComponentProps } from './bump_controller';
import { formatBid } from './bump_helpers';

const COMPONENT_NAME = 'ListingRowBumpButton';

interface SuccessCalloutProps {
  successMessage: string;
  bid: number;
}

function SuccessCallout(props: SuccessCalloutProps) {
  if (!props.successMessage) {
    return null;
  }

  const message = props.bid ? I18n.t('discovery.bump.successListingRow', { percent: formatBid(props.bid) }) : I18n.t('discovery.bump.successBidDelete');

  return (
    <div
      className="mini-bump-meter mini-bump-meter--new-bump scaling-mt-1"
    >
      {message}
      {' '}
      <CoreLink
        to={`${window.location.pathname}${window.location.search}`}
        onClick={(e) => {
          e.preventDefault();
          window.location.reload();
        }}
      >
        {I18n.t('discovery.bump.refreshPage')}
      </CoreLink>
    </div>
  );
}

export function ListingRowBumpButton(props: WrappedBumpComponentProps) {
  return (
    <div className="align-center">
      <button
        type="button"
        className="listing-row__action__trigger"
        onClick={props.openModal}
      >
        {I18n.t('discovery.bumpButton.buttonListingRow')}
      </button>
      <SuccessCallout successMessage={props.successMessage} bid={props.bid} />
      <BumpModalShell
        isOpen={props.showModal}
        onRequestClose={props.closeModal}
        bid={props.bid}
        showCustomWarning={props.showCustomWarning}
        onSubmit={props.onSubmit}
        onNoThankYou={props.onNoThankYou}
        showTopPickVariant={props.showTopPickVariant}
      >
        <BumpRecommendationBody
          hideSubmit
          hideSuccessMessage
          bid={props.bid}
          selectedBid={props.selectedBid}
          handleBidChange={props.handleBidChange}
          listing={props.listing}
          bumpRecommendationAmount={props.bumpRecommendationAmount}
          listingLoading={props.listingLoading}
          successMessage={props.successMessage}
          failMessage={props.failMessage}
          showCustomWarning={props.showCustomWarning}
          setShowCustomWarning={props.setShowCustomWarning}
          onSubmit={props.onSubmit}
          showTopPickVariant={props.showTopPickVariant}
        />
      </BumpModalShell>
    </div>
  );
}

const ListingRowBumpButtonContainer = bumpRecommendationsController(ListingRowBumpButton);

export default (props: BumpControllerProps) => {
  return (
    <ListingRowBumpButtonContainer
      componentName={COMPONENT_NAME}
      listingId={props.listingId}
      bid={props.bid}
      refetch={() => { }}
    />
  );
};
